export * from './tm-catalog'
export * from './tm-generic'
export * from './tm-login'
export * from './tm-register'
export * from './tm-product-detail'
export * from './tm-sidebar'
